module.exports = "<div class=\"main-container\">\n  <router-outlet></router-outlet>\n<div>\n"


//////////////////
// WEBPACK FOOTER
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main